<a
  href="#content-layout-body"
  class="skip-link"
  tabindex="0"
  (click)="onSkipToContent($event)"
>
  Skip to Content
</a>

<div
  aria-live="polite"
  aria-atomic="true"
  role="status"
  class="sr-only"
>
  {{ announcement }}
</div>

@if (hideNavigation !== undefined) {
<mat-sidenav-container>
  <mat-sidenav
    [fixedInViewport]="true"
    [mode]="isMobile() ? 'over' : 'side'"
    [opened]="!hideNavigation && sidenavState !== 'closed'"
    (openedChange)="onOpenedChange($event)"
    [@sidenavAnimation]="sidenavState"
    [disableClose]="!isMobile()"
    (@sidenavAnimation.start)="onAnimationStart($event)"
    (@sidenavAnimation.done)="onAnimationDone($event)"
  >
    <sidebar
      [state]="sidenavState"
      [isMobile]="isMobile"
      [parentAnimating]="isAnimating"
      [currentRoute]="currentRoute"
      [hideNavigation]="hideNavigation"
      (companyMenuOpened)="companyMenuOpened = $event"
      (toggleSidenav)="toggleSidenav()"
    >
    </sidebar>
  </mat-sidenav>
  <mat-sidenav-content [@sidenavContentAnimation]="sidenavState">
    <div id="content-layout">
      <div
        id="content-layout-header"
        resizeObserver
        (resizeEvent)="onHeaderResize($event)"
      >
        <common-header
          [hideNavigation]="hideNavigation"
          (openMobileMenu)="openMobileMenu()"
        ></common-header>
      </div>
      <div #contentLayoutBody id="content-layout-body" tabindex="-1">
        <ui-view></ui-view>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
}
